// The display and dispatch use the same target selected by the Space loader.
// qasInstance is the legacy field name for the next available stage.
export function transportTargetStage(space) {
  return String(space?.zielStufe || space?.qasInstance?.stage || "qas").toLowerCase().replaceAll("-", "");
}

export function transportTargetIndex(space) {
  const key = transportTargetStage(space);
  return (space?.stages || []).findIndex(stage =>
    String(stage.stageKey || stage.code || "").toLowerCase().replaceAll("-", "") === key);
}
